<template>
  <div class="order-success" :class="{
      'show': orderSuccessVisible,
      'heightFootBottom': isHeightFoot,
  }">
    <div>点歌成功</div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      timer: null,
      count: 0,
    }
  },
  computed: {
    ...mapState({
      orderSuccessVisible: (state) => state.orderSuccessVisible,
      appHistory: (state) => state.appHistory,
      role: (state) => state.role,
    }),
    isHeightFoot() {
      return this.appHistory < 2 && /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
    },
  },
  watch: {
    orderSuccessVisible(val) {
      if (val) {
        this.timer = setTimeout(() => {
          this.$store.commit('SET_ORDERSUCCESS_TOAST', false)
          clearTimeout(this.timer)
          this.timer = null
        }, 4000)
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer = null
  },
}
</script>

<style lang="scss" scoped>
.order-success {
  position: fixed;
  z-index: 1000;
  bottom: 136px;
  left: 50%;
  margin-left: -140px;
  width: 280px;
  height: 100px;
  background: rgba(0,0,0,0.75);
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 32px;
  color: #FFFFFF;
  padding: 0 20px 0 30px;
  visibility: hidden;
  &.show {
    visibility: visible;
  }
  div:first-child {
    background: url(https://qncweb-back1.ktvsky.com/20230418/other/5e65b2828cfa73074d02c597d95eb0f4.png) no-repeat left center;
    background-size: 36px auto;
    padding-left: 58px;
    font-weight: 400;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 36px;
    display: flex;
    p {
      color: #FFD69D;
      font-size: 24px;
      margin-left: 23px;
    }
  }
}
.heightFootBottom {
  position: fixed;
  bottom: 164px;
}
</style>
